/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface TuteurEditDto
 */
export interface TuteurEditDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idtuteur?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idtuteurLieu?: number;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idlieuFormation?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    codePaysNaissance?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurEditDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    numeroIdentification?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof TuteurEditDto
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof TuteurEditDto
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof TuteurEditDto
     */
    email?: EmailDto;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    tuteurActif?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    fonction?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurEditDto
     */
    sortieEntreprise?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    contactPrincipal?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    capaciteFormative?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurEditDto
     */
    dateCv?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idfichierCv?: number | null;
    /**
     * 
     * @type {FileUploadDto}
     * @memberof TuteurEditDto
     */
    fichierCv?: FileUploadDto;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    anneesExperience?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    tutorat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    vdc?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    derogation?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idresponsableDerogation?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TuteurEditDto
     */
    dateDerogation?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idfichierDerogation?: number | null;
    /**
     * 
     * @type {FileUploadDto}
     * @memberof TuteurEditDto
     */
    fichierDerogation?: FileUploadDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof TuteurEditDto
     */
    idmetiers?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurEditDto
     */
    photo?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurEditDto
     */
    idfichierPhoto?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    spp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TuteurEditDto
     */
    capaciteFormativeAtteinte?: boolean | null;
}

/**
 * Check if a given object implements the TuteurEditDto interface.
 */
export function instanceOfTuteurEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurEditDtoFromJSON(json: any): TuteurEditDto {
    return TuteurEditDtoFromJSONTyped(json, false);
}

export function TuteurEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'idtuteurLieu': !exists(json, 'idtuteurLieu') ? undefined : json['idtuteurLieu'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codePaysNaissance': !exists(json, 'codePaysNaissance') ? undefined : json['codePaysNaissance'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'numeroIdentification': !exists(json, 'numeroIdentification') ? undefined : json['numeroIdentification'],
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'tuteurActif': !exists(json, 'tuteurActif') ? undefined : json['tuteurActif'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
        'sortieEntreprise': !exists(json, 'sortieEntreprise') ? undefined : (json['sortieEntreprise'] === null ? null : new Date(json['sortieEntreprise'])),
        'contactPrincipal': !exists(json, 'contactPrincipal') ? undefined : json['contactPrincipal'],
        'capaciteFormative': !exists(json, 'capaciteFormative') ? undefined : json['capaciteFormative'],
        'dateCv': !exists(json, 'dateCv') ? undefined : (json['dateCv'] === null ? null : new Date(json['dateCv'])),
        'idfichierCv': !exists(json, 'idfichierCv') ? undefined : json['idfichierCv'],
        'fichierCv': !exists(json, 'fichierCv') ? undefined : FileUploadDtoFromJSON(json['fichierCv']),
        'anneesExperience': !exists(json, 'anneesExperience') ? undefined : json['anneesExperience'],
        'tutorat': !exists(json, 'tutorat') ? undefined : json['tutorat'],
        'vdc': !exists(json, 'vdc') ? undefined : json['vdc'],
        'derogation': !exists(json, 'derogation') ? undefined : json['derogation'],
        'idresponsableDerogation': !exists(json, 'idresponsableDerogation') ? undefined : json['idresponsableDerogation'],
        'dateDerogation': !exists(json, 'dateDerogation') ? undefined : (json['dateDerogation'] === null ? null : new Date(json['dateDerogation'])),
        'idfichierDerogation': !exists(json, 'idfichierDerogation') ? undefined : json['idfichierDerogation'],
        'fichierDerogation': !exists(json, 'fichierDerogation') ? undefined : FileUploadDtoFromJSON(json['fichierDerogation']),
        'idmetiers': !exists(json, 'idmetiers') ? undefined : json['idmetiers'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'photo': !exists(json, 'photo') ? undefined : json['photo'],
        'idfichierPhoto': !exists(json, 'idfichierPhoto') ? undefined : json['idfichierPhoto'],
        'spp': !exists(json, 'spp') ? undefined : json['spp'],
        'capaciteFormativeAtteinte': !exists(json, 'capaciteFormativeAtteinte') ? undefined : json['capaciteFormativeAtteinte'],
    };
}

export function TuteurEditDtoToJSON(value?: TuteurEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtuteur': value.idtuteur,
        'idtuteurLieu': value.idtuteurLieu,
        'idlieuFormation': value.idlieuFormation,
        'nom': value.nom,
        'prenom': value.prenom,
        'codesexe': value.codesexe,
        'nationalite': value.nationalite,
        'codePaysNaissance': value.codePaysNaissance,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'registreNational': value.registreNational,
        'numeroIdentification': value.numeroIdentification,
        'telephone': TelephoneDtoToJSON(value.telephone),
        'gsm': TelephoneDtoToJSON(value.gsm),
        'email': EmailDtoToJSON(value.email),
        'remarque': value.remarque,
        'actif': value.actif,
        'tuteurActif': value.tuteurActif,
        'fonction': value.fonction,
        'sortieEntreprise': value.sortieEntreprise === undefined ? undefined : (value.sortieEntreprise === null ? null : value.sortieEntreprise.toISOString()),
        'contactPrincipal': value.contactPrincipal,
        'capaciteFormative': value.capaciteFormative,
        'dateCv': value.dateCv === undefined ? undefined : (value.dateCv === null ? null : value.dateCv.toISOString()),
        'idfichierCv': value.idfichierCv,
        'fichierCv': FileUploadDtoToJSON(value.fichierCv),
        'anneesExperience': value.anneesExperience,
        'tutorat': value.tutorat,
        'vdc': value.vdc,
        'derogation': value.derogation,
        'idresponsableDerogation': value.idresponsableDerogation,
        'dateDerogation': value.dateDerogation === undefined ? undefined : (value.dateDerogation === null ? null : value.dateDerogation.toISOString()),
        'idfichierDerogation': value.idfichierDerogation,
        'fichierDerogation': FileUploadDtoToJSON(value.fichierDerogation),
        'idmetiers': value.idmetiers,
        'idpersonne': value.idpersonne,
        'photo': value.photo,
        'idfichierPhoto': value.idfichierPhoto,
        'spp': value.spp,
        'capaciteFormativeAtteinte': value.capaciteFormativeAtteinte,
    };
}

